// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"cardWrapper--2JxmFywi","disable":"disable--3WgZf1hu"};